<template>
    <section class="section bg-secondary">
        <div class="container">
            <div class="row row-grid align-items-center">
                <div class="col-md-6">
                    <div class="card bg-default shadow border-0">
                        <img v-lazy="'img/theme/taxes-preview.png'" class="card-img-top">
                        <blockquote class="card-blockquote">
                            <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 583 95"
                                    class="svg-bg">
                                <polygon points="0,52 583,95 0,95" class="fill-default"></polygon>
                                <polygon points="0,42 583,95 683,0 0,95" opacity=".2" class="fill-default"></polygon>
                            </svg>
                            <h4 class="display-3 font-weight-bold text-white" v-html="$t('taxes')"></h4>
                            <p class="lead text-italic text-white" v-html="$t('summary')"></p>
                        </blockquote>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="pl-md-5">
                        <div class="d-flex px-3">
                            <div>
                                <icon name="fa fa-trophy" size="lg" type="warning" shadow rounded></icon>
                            </div>
                            <div class="pl-4">
                                <h4 class="display-3" v-html="$t('achievements')"></h4>
                            </div>
                        </div>

                        <p class="lead">I am passionated about the Open Source world, it is fresh, dynamic, it is why I've been implicated into various Open Source project:</p>
                        <ul>
                            <li><a href="https://github.com/eclipse/buildship/pull/585">Contribution</a> to the Gradle Eclipse plugin Buildship to add editor with syntax highlighting</li>
                            <li><a href="https://github.com/cmoine/arangobee">Arangobee</a>: Port of the Mongobee project for the ArangoDB</li>
                            <li><a href="https://github.com/cmoine/generic-enums">Generic Enums</a>: Annotation processor for Java to provide Generic Enums in Java (aka JEP 301)</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
}
</script>

<style>

</style>

<i18n>
{
  "en": {
      "achievements": "Achievements",
      "taxes": "Property Taxes",
      "summary": "Living in a particularly taxed region of France, I decided to take advantage of OpenData to have a map of the most taxed municipalities in France..."
  },
  "fr": {
      "achievements": "R&eacute;alisations",
      "taxes": "Taxes fonci&egrave;res",
      "summary": "Habitant une r&eacute;gion de France particuli&egrave;remetn tax&eacute;e, j'ai d&eacute;cid&eacute; de tirer profit de l'OpenData pour avoir une carte des communes les plus tax&eacute;es en France..."
  }
}
</i18n>